import { MAX_REVIEW_STARS } from '../constants/reviews';

const writeReviewModalDefault = (review, isMultiPackage = false) => {
  return {
    title: '',
    imageUrl: '',
    version: review.productMetadata?.upm?.packageVersion ?? '',
    ownedDate: '',
    isMultiPackage,
    data: {
      id: review.id,
      rating: review.rating ?? 0,
      title: review.title ?? '',
      review: review.body ?? '',
    },
  };
};

export const productReviewsDataMapper = (
  review,
  options?: { includeWriteReviewModal?: boolean; isMultiPackage?: boolean }
) => {
  const baseURL = process.env.SITE_URL || 'https://assetstore.unity.com';

  return {
    id: review.id,
    reviewerInfo: {
      name: review.userProfile?.name ?? '',
      link: `${baseURL}/users/${review.userProfile?.id || ''}`,
      avatarUrl: review.userProfile?.image || '',
      // TODO: Consider exposing additional reviewer profile metadata (e.g., memberSince, reviewCount, helpfulVoteCount) when available from the backend.
    },
    reviewDetails: {
      id: review.id,
      ownedDate: '', // This will be set by the caller when needed
      canSubmitReview: false, // This will be set by the caller when needed
      stars: {
        value: review.rating ?? 0,
        max: MAX_REVIEW_STARS,
      },
      review: review.body ?? '',
      gifted: false,
      version: review.productMetadata?.upm?.packageVersion ?? '',
      title: review.title ?? '',
      publishedDate: review.createdAt,
      canReportReview: review.permissions?.canReport ?? false,
      canEdit: review.permissions?.canEdit ?? false,
      canDelete: review.permissions?.canDelete ?? false,
      canReply: false,
      canHelpfulVotes: review.permissions?.canMarkHelpful ?? false,
      reply: undefined,
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.isMultiPackage
      ),
    },
    ...(options?.includeWriteReviewModal && {
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.isMultiPackage
      ),
    }),
  };
};
